import { render, staticRenderFns } from "./LevelChooser.vue?vue&type=template&id=8da653bc&scoped=true&"
import script from "./LevelChooser.vue?vue&type=script&lang=js&"
export * from "./LevelChooser.vue?vue&type=script&lang=js&"
import style0 from "./LevelChooser.vue?vue&type=style&index=0&id=8da653bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da653bc",
  null
  
)

export default component.exports